import { LinearProgress } from '@material-ui/core';
import {
  Conversa,
  Duvida,
  MensagensFiltros,
  PaginationDuvidas,
} from 'api/Assessor/duvidas';
import LayoutContext from 'components/Layout/LayoutContext';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import Page from 'components/__SHARED__/PrivateContainer';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  assembleiasAssessorActionsLoadDuvidas,
  assembleiasAssessorLoadEvento,
} from 'store/modules/AssembleiasAssessorActions';
import { IReducer } from 'store/Reducer';
import Chat, { toggleResponse } from './Chat';
import Context from './Context';
import ListaConversas from './Conversas';
import Header from './Header';
import { mensagensInitialState, mensagensReducer } from './reducer';
import useStyle from './style';

interface PathParams {
  idEvento: string;
}

export default function MensagensAssessor() {
  const { headerHeight } = useContext(LayoutContext);
  const classes = useStyle({ headerHeight });
  const { idEvento } = useParams<PathParams>();
  const { loadingEvento, evento, loadingDuvidas, duvidas } = useSelector(
    (state: IReducer) => state.assembleiasAssessor
  );
  const auth = useSelector(
    (state: IReducer) =>
      state.auth.usuario?.perfil.assessorRoute.duvidasSugestoes
  );
  const dispatch = useDispatch();
  const [{ conversaAtual, filtros }, action] = useReducer(
    mensagensReducer,
    mensagensInitialState
  );
  const [dAtual, setDAtual] = useState<Duvida>();

  const setConversa = (value: Conversa | null) =>
    action({ type: 'setConversa', value });

  const pesquisar = useCallback(
    (termo: string) =>
      action({
        type: 'setFiltro',
        value: {
          ...filtros,
          page: 1,
          nomeAssociadoOrCpf: termo.length > 0 ? termo : undefined,
        },
      }),
    [filtros]
  );

  const filtroRespondidos = useCallback(
    (respondido: boolean | undefined) => {
      action({
        type: 'setFiltro',
        value: {
          ...filtros,
          page: 1,
          flgEmResposta: respondido && undefined,
          respondido,
        },
      });
    },
    [filtros]
  );

  const filtroEmResposta = useCallback(
    (flgEmResposta: boolean | undefined) => {
      action({
        type: 'setFiltro',
        value: {
          ...filtros,
          page: 1,
          respondido: flgEmResposta && undefined,
          flgEmResposta,
        },
      });
    },
    [filtros]
  );

  const irParaPagina = useCallback(
    (page: number) => {
      action({
        type: 'setFiltro',
        value: {
          ...filtros,
          page,
        },
      });
      setConversa(null);
    },
    [filtros]
  );

  const irParaConversa = useCallback(
    (cpfUsuario: string) => {
      const conversa = duvidas.elements.find(
        (usuario) => usuario.cpfUsuario === cpfUsuario
      );
      setConversa(conversa || null);
    },
    [duvidas]
  );

  const atualizarEvento = useCallback(() => {
    dispatch(
      assembleiasAssessorLoadEvento(parseInt(idEvento), undefined, () => {
        // history.push(AssembleiaAssessorRoutePath);
      })
    );
  }, [dispatch, idEvento]);

  const limparFiltros = (filtros: MensagensFiltros) => {
    return Object.keys(filtros).reduce((acc, cur) => {
      if (filtros[cur] !== undefined) {
        return {
          ...acc,
          [cur]: filtros[cur],
        };
      }
      return acc;
    }, {});
  };

  const atualizarMensagens = useCallback(
    (successCb?: (conversas: PaginationDuvidas) => void) => {
      const cb = () => {
        dispatch(
          assembleiasAssessorActionsLoadDuvidas(
            parseInt(idEvento),
            limparFiltros(filtros),
            (conversas: PaginationDuvidas) => {
              successCb && successCb(conversas);
            },
            ErrorHandler
          )
        );
      };

      if (loadingDuvidas) return;

      if (dAtual) {
        toggleResponse(
          {
            idDuvida: dAtual!?.idDuvidaFrequente,
            flgEmEdicao: Boolean(dAtual!?.resposta),
            flgEmResposta: false,
          },
          cb,
          cb
        );
      } else {
        cb();
      }
    },
    [dispatch, idEvento, filtros, loadingDuvidas, dAtual]
  );

  useEffect(() => {
    atualizarEvento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEvento]);

  useEffect(() => {
    pesquisar('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evento]);

  useEffect(() => {
    atualizarMensagens();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros]);

  useEffect(() => {
    irParaConversa(conversaAtual?.cpfUsuario || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duvidas]);

  return (
    <Context.Provider
      value={{
        conversas: duvidas,
        evento,
        conversaAtual,
        irParaConversa,
        atualizarMensagens,
        auth,
        termoPesquisa: filtros.nomeAssociado,
        pesquisar,
        atualizarEvento,
        filtroRespondidos,
        filtroEmResposta,
        irParaPagina,
        paginaAtual: filtros.page || 1,
        dAtual,
        setDAtual,
      }}
    >
      <Page className={classes.root} contentClassName={classes.content}>
        <div className={[classes.side, classes.left].join(' ')}>
          {loadingDuvidas && <LinearProgress className={classes.loading} />}
          <Header />
          <ListaConversas />
        </div>
        <div className={[classes.side, classes.right].join(' ')}>
          <Chat />
        </div>
      </Page>
      {loadingEvento && <Loading />}
    </Context.Provider>
  );
}
